import type { ReactNode } from 'react';
import { cx } from '../../utils/cx';
import s from './KeyValue.module.css';

export type KeyValueProps = {
  items: Array<{ key: string; label: ReactNode; value: ReactNode }>;
  className?: string;
};

/** A definition list: label on the left (top on narrow screens), value on the right. */
export function KeyValue({ items, className }: KeyValueProps) {
  return (
    <dl className={cx(s.list, className)}>
      {items.map((it) => (
        <div key={it.key} className={s.row}>
          <dt className={s.label}>{it.label}</dt>
          <dd className={s.value}>{it.value}</dd>
        </div>
      ))}
    </dl>
  );
}
